import { EmptyState, PageHead } from '../components/ui.js';
import type { NavItem } from '../nav.js';

/** An entry of the navigation whose screen comes with a later build step. */
export function Soon({ item }: { item: NavItem }) {
  return (
    <>
      <PageHead title={item.menuLabel ?? item.label} />
      <EmptyState title="Not built yet">
        This screen comes with build step {item.step} of the portal.
      </EmptyState>
    </>
  );
}
